import { Info } from '@mui/icons-material';
import { Dialog, Slide, useTheme } from '@mui/material';
import type { TransitionProps } from '@mui/material/transitions';
import { Legend } from 'components/Cards';
import { type FC, forwardRef, type ReactElement, type Ref, useState } from 'react';

const Transition = forwardRef(function Transition(
  props: TransitionProps & { children: ReactElement<any, any> },
  ref: Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const AvaniLineConditionDialog: FC = ({}) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = (e: any) => {
    e.stopPropagation();
    setOpen(true);
  };

  const handleClose = (e: any) => {
    e.stopPropagation();
    setOpen(false);
  };

  const theme = useTheme();

  return (
    <span style={{ marginLeft: 16 }}>
      <Info
        fontSize={'large'}
        color={'aYellow'}
        onClick={(e) => handleClickOpen(e)}
        sx={{ cursor: 'pointer', '&:hover': { color: 'teal' } }}
      />
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={(e) => handleClose(e)}
        aria-describedby="alert-dialog-slide-description"
        slotProps={{ backdrop: { style: { backgroundColor: theme.colors.avani.turc, opacity: 0.3 } } }}
      >
        <Legend />
      </Dialog>
    </span>
  );
};
